import React, { Component } from "react";
import { Redirect, Route, RouteComponentProps, withRouter } from "react-router-dom";
import {
  IonPage,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonImg,
  isPlatform,
} from "@ionic/react";

// CSS

// Images
import buttonDashboardActive from "./assets/TabBar_Dashboard_2Active@3x.png";
import buttonDashboardInactive from "./assets/TabBar_Dashboard_1Inactive@3x.png";
import buttonGuidelinesActive from "./assets/TabBar_Guidelines_2Active@3x.png";
import buttonGuidelinesInactive from "./assets/TabBar_Guidelines_1Inactive@3x.png";
import buttonMedsActive from "./assets/TabBar_Meds_2Active@3x.png";
import buttonMedsInactive from "./assets/TabBar_Meds_1Inactive@3x.png";
import buttonAlgorithmsActive from "./assets/TabBar_Algorithms_2Active@3x.png";
import buttonAlgorithmsInactive from "./assets/TabBar_Algorithms_1Inactive@3x.png";
import buttonPageForAgeInactive from "./assets/TabBar_PageforAge_1Inactive@3x.png";
import buttonPageForAgeActive from "./assets/TabBar_PageforAge_2Active@3x.png";
import buttonPathwaysInactive from "./assets/TabBar_Pathways_1Inactive@3x.png";
import buttonPathwaysActive from "./assets/TabBar_Pathways_2Active@3x.png";

import buttonDashboardActiveDark from "./assets/TabBar_Dashboard_3Dark@3x.png";
import buttonGuidelinesActiveDark from "./assets/TabBar_Guidelines_3Dark@3x.png";
import buttonMedsActiveDark from "./assets/TabBar_Meds_3Dark@3x.png";
import buttonAlgorithmsActiveDark from "./assets/TabBar_Algorithms_3Dark@3x.png";
import buttonPageForAgeActiveDark from "./assets/TabBar_PageforAge_3Dark@3x.png";
import buttonPathwaysActiveDark from "./assets/TabBar_Pathways_3Dark@3x.png";
import buttonEssentialsActive from "./assets/Tab_Essentials_Active@3x.png";
import buttonEssentialsInactive from "./assets/Tab_Essentials_Inactive@3x.png";
import buttonEssentialsActiveDark from "./assets/Tab_Essentials_Active_Dark@3x.png";

// Controllers
import { IScreenProps } from "./Interfaces";
import RemoteDataController from "./controllers/RemoteDataController";

// Pages
import DashboardPage from "./pages/dashboard/DashboardPage";
import ListPage from "./pages/list/ListPage";
import GuidelinePage from "./pages/guidelines/GuidelinePage";
import AlgorithmPage from "./pages/algorithms/AlgorithmPage";
import MenuPage from "./pages/menu/MenuPage";
import SignificantChangesListPage from "./pages/significantChagesList/SignificantChangesListPage";
import ClinicalNoticePage from "./pages/clinicalNotices/ClinicalNoticePage";
import PathwaysListPage from "./pages/pathways/PathwaysListPage";
import PathwayPage from "./pages/pathways/PathwayPage";
import EditDashboardPage from "./pages/dashboard/EditDashboardPage";
import EssentialsPage from "./pages/essentials/EssentialsPage";
import NotificationsListPage from "./pages/notifications/NotificationsListPage";
import HelpCentrePage from "./pages/help/HelpCentrePage";
import HelpCentreDetailPage from "./pages/help/HelpCentreDetailPage";
import ContactPage from "./pages/help/ContactPage";

type Props = RouteComponentProps<{}> & {
  screenProps: IScreenProps;
  features: string[];
};
type State = {
  compactTabBar: boolean;
};

class AppStack extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      compactTabBar: false,
    };
  }

  componentDidMount() {
    this.windowWasResized();
    window.addEventListener("resize", this.windowWasResized.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.windowWasResized.bind(this));
  }

  windowWasResized() {
    let compactTabBar = false;
    if (window.innerWidth < 600) {
      compactTabBar = true;
    }

    if (compactTabBar !== this.state.compactTabBar) {
      this.setState({ compactTabBar });
    }
  }

  logTabPressed(tab: string) {
    try {
      RemoteDataController.logEvent("tab_clicked", { tab: tab });
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    let content: any = document.getElementsByTagName("ion-tab-bar")[0];

    let dashboardIcon = buttonDashboardInactive;
    let guidelinesIcon = buttonGuidelinesInactive;
    let medsIcon = buttonMedsInactive;
    let algorithmsIcon = buttonAlgorithmsInactive;
    let pageForAgeIcon = buttonPageForAgeInactive;
    let pathwaysIcon = buttonPathwaysInactive;
    let essentialsIcon = buttonEssentialsInactive;

    let selectedTab = "";
    if (content != null) {
      selectedTab = content.selectedTab;
    }

    if (selectedTab === "dashboard" || this.props.location.pathname === "/dashboard") {
      dashboardIcon = this.props.screenProps.darkMode ? buttonDashboardActiveDark : buttonDashboardActive;
    } else if (selectedTab === "guidelines" || this.props.location.pathname === "/guidelines") {
      guidelinesIcon = this.props.screenProps.darkMode ? buttonGuidelinesActiveDark : buttonGuidelinesActive;
    } else if (selectedTab === "meds" || this.props.location.pathname === "/meds") {
      medsIcon = this.props.screenProps.darkMode ? buttonMedsActiveDark : buttonMedsActive;
    } else if (selectedTab === "algorithms" || this.props.location.pathname === "/algorithms") {
      algorithmsIcon = this.props.screenProps.darkMode ? buttonAlgorithmsActiveDark : buttonAlgorithmsActive;
    } else if (selectedTab === "pageforage" || this.props.location.pathname === "/pageforage") {
      pageForAgeIcon = this.props.screenProps.darkMode ? buttonPageForAgeActiveDark : buttonPageForAgeActive;
    } else if (selectedTab === "pathways" || this.props.location.pathname === "/pathways") {
      pathwaysIcon = this.props.screenProps.darkMode ? buttonPathwaysActiveDark : buttonPathwaysActive;
    } else if (selectedTab === "essentials" || this.props.location.pathname === "/essentials") {
      essentialsIcon = this.props.screenProps.darkMode ? buttonEssentialsActiveDark : buttonEssentialsActive;
    } else {
      dashboardIcon = buttonDashboardActive;
    }

    let compactTabBar = this.state.compactTabBar;

    return (
      <IonPage>
        <MenuPage features={this.props.features} screenProps={this.props.screenProps} />
        <IonTabs>
          <IonRouterOutlet id="main" mode="ios">
            <Route
              exact
              path="/:tab(dashboard)"
              render={() => (
                <DashboardPage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route
              exact
              path="/:tab(guidelines)"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="Guidelines"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(meds)"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="Meds"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(algorithms)"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="Algorithms"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(pageforage)"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="PageForAge"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(pathways)"
              render={() => (
                <PathwaysListPage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route
              exact
              path="/:tab(pathways)/:id"
              render={() => (
                <PathwayPage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route
              exact
              path="/:tab(essentials)"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="Essentials"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(essentials)/:id"
              render={() => (
                <EssentialsPage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route
              exact
              path="/:tab(guidelines)/:id"
              render={() => (
                <GuidelinePage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route
              exact
              path="/:tab(meds)/:id"
              render={() => (
                <GuidelinePage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route
              exact
              path="/:tab(algorithms)/:id"
              render={() => (
                <AlgorithmPage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route
              exact
              path="/:tab(pageforage)/:id"
              render={() => (
                <GuidelinePage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/updates"
              render={() => (
                <SignificantChangesListPage
                  {...this.props}
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/edit"
              render={() => (
                <EditDashboardPage
                  {...this.props}
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/clinicalnotices"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="ClinicalNotices"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/local-clinical-updates"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="LocalClinicalUpdates"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/bookmarks"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="Bookmarks"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/recentlyviewed"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="RecentlyViewed"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/clinicalnotices/:id"
              render={() => (
                <ClinicalNoticePage
                  {...this.props}
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/guideline-acks"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="AcknowledgeableGuidelines"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/pgds"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="PGDs"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/pmas"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="PMAs"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/supplementary-medication-guidelines"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="SMGs"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/medication-supply-guidelines"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="SMGs"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/covid19"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="Covid19"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/timecritical"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="TimeCritical"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/sharedprocedures"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="SharedProcedures"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/pin/:id"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="TrustPin"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/trustguidelines"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="Guidelines"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/trustmedsguidelines"
              render={() => (
                <ListPage
                  {...this.props}
                  listType="TrustGuidelines"
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/notifications"
              render={() => (
                <NotificationsListPage
                  {...this.props}
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/helpcentre"
              render={() => (
                <HelpCentrePage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/helpcentre/:id"
              render={() => (
                <HelpCentreDetailPage
                  {...this.props}
                  features={this.props.features}
                  screenProps={this.props.screenProps}
                />
              )}
            />
            <Route
              exact
              path="/:tab(dashboard)/contact"
              render={() => (
                <ContactPage {...this.props} features={this.props.features} screenProps={this.props.screenProps} />
              )}
            />
            <Route exact path="/">
              <Redirect to="/dashboard" />
            </Route>
            <Route render={() => <Redirect to={"/dashboard"} />} />
          </IonRouterOutlet>
          <IonTabBar
            slot="bottom"
            className={`${this.props.screenProps.tabBarVisible ? "" : "tabBarHidden"}`}
            onIonTabsDidChange={(e) => {
              this.logTabPressed(e.detail.tab);
            }}
          >
            <IonTabButton
              tab="dashboard"
              href="/dashboard"
              mode="ios"
              layout={compactTabBar ? "icon-top" : "icon-start"}
            >
              <IonImg src={dashboardIcon} className={compactTabBar ? "tabBarIconTop" : "tabBarIconStart"} />
              <IonLabel className={compactTabBar ? "tabBarLabelTop" : "tabBarLabelStart"}>{"Dashboard"}</IonLabel>
            </IonTabButton>

            <IonTabButton
              tab="guidelines"
              href="/guidelines"
              mode="ios"
              layout={compactTabBar ? "icon-top" : "icon-start"}
            >
              <IonImg src={guidelinesIcon} className={compactTabBar ? "tabBarIconTop" : "tabBarIconStart"} />
              <IonLabel className={compactTabBar ? "tabBarLabelTop" : "tabBarLabelStart"}>{"Guidelines"}</IonLabel>
            </IonTabButton>

            <IonTabButton tab="meds" href="/meds" mode="ios" layout={compactTabBar ? "icon-top" : "icon-start"}>
              <IonImg src={medsIcon} className={compactTabBar ? "tabBarIconTop" : "tabBarIconStart"} />
              <IonLabel className={compactTabBar ? "tabBarLabelTop" : "tabBarLabelStart"}>{"Meds"}</IonLabel>
            </IonTabButton>

            <IonTabButton
              tab="algorithms"
              href="/algorithms"
              mode="ios"
              layout={compactTabBar ? "icon-top" : "icon-start"}
            >
              <IonImg src={algorithmsIcon} className={compactTabBar ? "tabBarIconTop" : "tabBarIconStart"} />
              <IonLabel className={compactTabBar ? "tabBarLabelTop" : "tabBarLabelStart"}>{"Algorithms"}</IonLabel>
            </IonTabButton>

            {this.props.screenProps.app === "CFR" ? (
              <IonTabButton
                tab="essentials"
                href="/essentials"
                mode="ios"
                layout={compactTabBar ? "icon-top" : "icon-start"}
              >
                <IonImg src={essentialsIcon} className={compactTabBar ? "tabBarIconTop" : "tabBarIconStart"} />
                <IonLabel className={compactTabBar ? "tabBarLabelTop" : "tabBarLabelStart"}>{"Essentials"}</IonLabel>
              </IonTabButton>
            ) : null}

            {this.props.screenProps.app !== "CFR" &&
            (this.props.features.includes("pathwaysTab") === false || this.props.screenProps.pathwayData == null) ? (
              <IonTabButton
                tab="pageforage"
                href="/pageforage"
                mode="ios"
                layout={compactTabBar ? "icon-top" : "icon-start"}
              >
                <IonImg src={pageForAgeIcon} className={compactTabBar ? "tabBarIconTop" : "tabBarIconStart"} />
                <IonLabel className={compactTabBar ? "tabBarLabelTop" : "tabBarLabelStart"}>{"Page for Age"}</IonLabel>
              </IonTabButton>
            ) : null}

            {this.props.features.includes("pathwaysTab") && this.props.screenProps.pathwayData != null ? (
              <IonTabButton
                tab="pathways"
                href="/pathways"
                mode="ios"
                layout={compactTabBar ? "icon-top" : "icon-start"}
              >
                <IonImg src={pathwaysIcon} className={compactTabBar ? "tabBarIconTop" : "tabBarIconStart"} />
                <IonLabel className={compactTabBar ? "tabBarLabelTop" : "tabBarLabelStart"}>{"Pathways"}</IonLabel>
              </IonTabButton>
            ) : null}
          </IonTabBar>
        </IonTabs>
      </IonPage>
    );
  }
}

export default withRouter(AppStack);
